<template>
    <div class="row">
        <div class="col-12">
            <card card-body-classes="table-full" no-footer-line>
                <h4 slot="header" class="card-title">Subscription Reports - <small>{{ user }} / {{ type }}</small></h4>
                <div>
                    <div class="d-flex justify-content-center justify-content-sm-between flex-wrap">
                        <div>
                            
                            <el-select
                                class="select-primary mb-3"
                                style="width: 200px; margin-right: 10px;"
                                v-model="pagination.perPage"
                                v-if="pagination"
                                placeholder="Per page"
                            >
                                <el-option class="select-primary" v-for="item in pagination.perPageOptions"
                                :key="item"
                                :label="item"
                                :value="item"
                                ></el-option>
                            </el-select>

                            <el-select
                                class="select-primary mb-3"
                                style="width: 200px; margin-right: 10px;"
                                v-model="user"
                                placeholder="User Type"
                            >
                                <el-option class="select-primary" v-for="item in users"
                                :key="item"
                                :label="item"
                                :value="item"
                                ></el-option>
                            </el-select>

                            <el-select
                                class="select-primary mb-3"
                                style="width: 200px; margin-right: 10px;"
                                v-model="type"
                                placeholder="Status Type"
                            >
                                <el-option class="select-primary" v-for="item in types"
                                :key="item"
                                :label="item"
                                :value="item"
                                ></el-option>
                            </el-select>

                            <el-select
                                class="select-primary mb-3"
                                style="width: 200px; margin-right: 10px;"
                                v-model="batch"
                                placeholder="Batch"
                                v-if="user == 'students' || user == 'parents'"
                            >
                                <el-option class="select-primary" label="All" :value="null" ></el-option>
                                <el-option class="select-primary" v-for="item in batches"
                                :key="item"
                                :label="item"
                                :value="item"
                                ></el-option>
                            </el-select>

                            <vue-json-to-csv :json-data="tableData"
                                :labels="csvTitles"
                                :csv-title="`${user}-${type}-report`"
                                >
                                <!-- <button>
                                    <b>My custom button</b>
                                </button> -->
                                <el-tooltip class="item" effect="dark" content="Download CSV Report" placement="right">
                                <n-button class="download" type="success" size="sm" round icon simple >
                                    <i class="fa fa-download"></i>
                                </n-button>
                                </el-tooltip>
                            </vue-json-to-csv>

                        </div>

                        <div>
                            <fg-input>
                                <el-input type="search"  class="mb-3" style="width: 400px"
                                prefix-icon="el-icon-search"
                                :placeholder="`Search by ${propsToSearch.join(', ').trim(', ').replace('.',' ')}`"
                                v-model="searchQuery"
                                aria-controls="datatables"
                                ></el-input>
                            </fg-input>
                        </div>
                        
                        
                    </div>
                    <el-table stripe style="width: 100%;" :data="queriedData" size="mini">
                        <el-table-column
                            v-for="(column, index) in tableColumns"
                            :key="index"
                            :min-width="column.minWidth"
                            :prop="column.prop"
                            :label="column.label"
                            :sortable="column.sortable || false"
                            :align="column.align"
                            :header-align="column.align"
                            v-if="!column.hidden"
                            :fixed="column.fixed || false"
                            :formatter="column.formatter || null"
                        ></el-table-column>
                        
                        <el-table-column :min-width="180" fixed="right" label="Actions" align="right" v-if="false">
                            <div slot-scope="props" class="table-actions">
                                <el-tooltip class="item" effect="dark" content="View" placement="top">
                                    <n-button
                                        @click.native="handleView(props.$index, props.row)"
                                        class="view"
                                        type="primary"
                                        size="sm"
                                        round
                                        icon
                                        simple
                                    >
                                        <i class="fa fa-eye"></i>
                                    </n-button>
                                </el-tooltip>
                                <el-tooltip class="item" effect="dark" content="Edit" placement="top">
                                    <n-button
                                        @click.native="handleEdit(props.$index, props.row)"
                                        class="edit"
                                        type="warning"
                                        size="sm"
                                        round
                                        icon
                                        simple
                                    >
                                        <i class="fa fa-pencil"></i>
                                    </n-button>
                                </el-tooltip>
                                <el-tooltip class="item" effect="dark" content="Delete" placement="top">
                                    <n-button
                                        @click.native="handleDelete(props.$index, props.row)"
                                        class="remove"
                                        type="danger"
                                        size="sm"
                                        round
                                        icon
                                        simple
                                    >
                                        <i class="fa fa-times"></i>
                                    </n-button>
                                </el-tooltip>
                                <el-tooltip class="item" effect="dark" content="Reset Password" placement="top">
                                    <n-button
                                        @click.native="handleReset(props.$index, props.row)"
                                        class="reset"
                                        type="success"
                                        size="sm"
                                        round
                                        icon
                                        simple
                                    >
                                        <i class="fa fa-refresh"></i>
                                    </n-button>
                                </el-tooltip>
                            </div>
                        </el-table-column>
                    </el-table>
                </div>
                <div
                    slot="footer"
                    class="d-flex justify-content-center justify-content-sm-between flex-wrap"
                >
                    <div class>
                    <p class="card-category">Showing {{from + 1}} to {{to}} of {{total}} entries</p>
                    </div>
                    <n-pagination
                    class="pagination-no-border"
                    v-model="pagination.currentPage"
                    :per-page="pagination.perPage"
                    :total="total"
                    ></n-pagination>
                </div>
            </card>
        </div>

    </div>
</template>

<script>
import { Table, TableColumn, Select, Option, Upload, Progress, DatePicker  } from "element-ui";
import { Pagination as NPagination  } from "src/components";
import Fuse from "fuse.js";
import swal from "sweetalert2";
import VueJsonToCsv from 'vue-json-to-csv'

import { mapGetters } from 'vuex';

export default {
    components: {
        NPagination,
        VueJsonToCsv,
        [Select.name]: Select,
        [Option.name]: Option,
        [Table.name]: Table,
        [TableColumn.name]: TableColumn,
        [Upload.name]: Upload,
        [Progress.name]: Progress,
        [DatePicker.name]: DatePicker
    },
    computed: {
        ...mapGetters({
            tableData: 'getSubscribers',
            batches: 'getBatches',
            authTokens: 'getAuthTokens',
            preferences: 'getPreferences'
        }),

        /***
         * Returns a page from the searched data or the whole data. Search is performed in the watch section below
         */
        queriedData() {
            let result = this.searchedData;
            // if (this.searchedData.length > 0) {
            //     result = this.searchedData;
            // }
            return result.slice(this.from, this.to);
        },
        to() {
            let highBound = this.from + this.pagination.perPage;
            if (this.total < highBound) {
                highBound = this.total;
            }
            return highBound;
        },
        from() {
            return this.pagination.perPage * (this.pagination.currentPage - 1);
        },
        total() {
            return this.searchedData.length > 0 ? this.searchedData.length : this.tableData.length;
        },
        headers(){
            // this.authTokens['content-type'] = 'application/x-www-form-urlencoded'
            this.authTokens['content-type'] = 'multipart/form-data'
            return this.authTokens;
        },
        uploadURL(){
            return `${process.env.VUE_APP_ADMIN_URL}/users/students/csv`
        }
    },
    data() {
        return {
            types: [
                'subscribers',
                'unsubscribers'
            ],
            users: [
                'students',
                'teachers',
                'parents'
            ],
            type: 'subscribers',
            user: 'students',
            batch: null,
            pagination: {
                perPage: 10,
                currentPage: 1,
                perPageOptions: [10, 25, 50, 100],
                total: 0
            },
            searchQuery: "",
            propsToSearch: [ "register_no", "name", "course", "section", "department", "deanery"],
            csvTitles: { 
                register_no : { title: "Register Number" }, 
                name : { title: "Name" },
                course : { title: "Course" },
                section : { title: "Section" },
                department : { title: "Department" },
                deanery : { title: "Deanery" }
            },
            tableColumns: [
                {
                    prop: "_id",
                    label: "ID",
                    hidden: true,
                    minWidth: 200,
                },
                {
                    prop: "register_no",
                    label: "Reg #",
                    minWidth: 200,
                    align: 'center',
                    sortable: true,
                    fixed: true,
                },
                {
                    prop: "name",
                    label: "Name",
                    minWidth: 250,
                    align: 'left',
                    sortable: true,
                    fixed: false,
                },
                {
                    prop: "course",
                    label: "Course",
                    minWidth: 250,
                    align: 'left',
                    sortable: true,
                    fixed: false,
                },
                {
                    prop: "section",
                    label: "Section",
                    minWidth: 150,
                    align: 'left',
                    sortable: true,
                    fixed: false,
                },
                {
                    prop: "session.start",
                    label: "S.Start",
                    minWidth: 150,
                    align: 'center',
                    sortable: true,
                    fixed: false,
                },
                {
                    prop: "session.end",
                    label: "S.End",
                    minWidth: 150,
                    align: 'center',
                    sortable: true,
                    fixed: false,
                },
                {
                    prop: "department",
                    label: "Department",
                    minWidth: 200,
                    align: 'left',
                    sortable: true,
                    fixed: false,
                },
                {
                    prop: "deanery",
                    label: "Deanery",
                    minWidth: 250,
                    align: 'left',
                    sortable: true,
                    fixed: false,
                }
            ],
            searchedData: [],
            fuseSearch: null
        };
    },
    methods: {
        handleView(index, row) {
            // handleView
        },
        handleEdit(index, row) {

            this.model = Object.assign({}, row);
            this.model.session_start = row.session.start
            this.model.session_end = row.session.end

            this.scope = 'edit'
            this.modals.add = true
        },
        handleDelete(index, row) {
            swal({
                title: "Are you sure?",
                text: `You won't be able to revert this!`,
                showCancelButton: true,
                confirmButtonClass: "btn btn-danger btn-fill",
                cancelButtonClass: "btn btn-default btn-fill",
                confirmButtonText: "Delete it!",
                buttonsStyling: false
            }).
            then(result => {
                if (result.value) {
                    this.deleteRow(row);
                }
            });
        },
        handleReset(index, row) {
            swal({
                title: "Are you sure?",
                text: `Password will be reset to the register number.`,
                showCancelButton: true,
                confirmButtonClass: "btn btn-danger btn-fill",
                cancelButtonClass: "btn btn-default btn-fill",
                confirmButtonText: "Reset Password!",
                buttonsStyling: false
            }).
            then(result => {
                if (result.value) {
                    this.$store.dispatch('resetPassword', {mail: row.mail})
                }
            });
        },
        deleteRow(row) {
            this.$store.dispatch('deleteStudent', row.user_id)
        }
    },
    mounted() {
        // Fuse search initialization.
        this.fuseSearch = new Fuse(this.tableData, {
            keys: this.propsToSearch,
            threshold: 0.1
        });

        this.$nextTick(() => {
            this.pagination.perPage = this.preferences.perPage
        })

        this.$store.dispatch('getSubscriptionReports', {
            type: this.type,
            user: this.user,
            batch: this.batch
        });

        this.$store.dispatch('getBatches');
    },
    watch: {
        /**
         * Searches through the table data by a given query.
         * NOTE: If you have a lot of data, it's recommended to do the search on the Server Side and only display the results here.
         * @param value of the query
         */
        searchQuery: {
            handler: function(value){
                let result = Object.assign([], this.tableData);
                if (value !== "") {
                    result = this.fuseSearch.search(value);
                }
                this.searchedData = result;
            },
            immediate: true
        },

        tableData: {
            handler: function(value){
                this.fuseSearch = new Fuse(value, {
                    keys: this.propsToSearch,
                    threshold: 0.1
                })
                let result = Object.assign([], value);
                if (this.searchQuery !== "") {
                    result = this.fuseSearch.search(this.searchQuery);
                }
                this.searchedData = result;
            },
            immediate: true
        },

        'pagination.perPage'(value){
            this.preferences.perPage = value
            this.$store.commit('setPreferences', this.preferences)
        },

        type(value){
            this.$store.dispatch('getSubscriptionReports', {
                type: this.type,
                user: this.user,
                batch: this.batch
            });
        },

        user(value){
            this.$store.dispatch('getSubscriptionReports', {
                type: this.type,
                user: this.user,
                batch: this.batch
            });
        },

        batch(value){
            this.$store.dispatch('getSubscriptionReports', {
                type: this.type,
                user: this.user,
                batch: this.batch
            });
        }
    }
};
</script>

<style lang="scss">
    .has-success.has-label:after, 
    .has-danger.has-label:after {
        top: 43px;
    }

    .el-transfer-panel__filter.el-input{
        width: 85%;
    }

    .upload-file{
        text-align: center;
    }

    p.status{
        text-align: center;
        width: 100%;
        display: block;
    }

    .el-upload__tip em {
        color: #409EFF;
        font-style: normal;
        cursor: pointer;
    }
    .el-progress{
        width: 75%;
        margin: 10px auto;
    }

    .el-progress-bar{
        margin-right: -25px;
        padding-right: 25px;
    }
</style>

